import React from 'react';

interface Props {
  title: string;
  subTitle: string;
  children: JSX.Element;
}

export const DashboardLibraryContentAddPanelSection = ({ title, subTitle, children }: Props) => (
  <div className='flex flex-col gap-y-4 text-bedrock-black'>
    <div>
      <h4 className='text-bedrock-p-strong'>{title}</h4>
      <p className='mt-0.5 text-bedrock-p'>{subTitle}</p>
    </div>
    {children}
  </div>
);
